const usuario = {
  createUsuarioChangePassword: 'usuario/change-password',
  createUsuarioConfirmForgotPassword: 'usuario/confirm-forgot-password',
  createUsuarioForgotPassword: 'usuario/forgot-password',
  createUsuarioLogin: 'usuario/login',
  createUsuarioRefreshToken: 'usuario/refresh-token',
  createUsuarioResetPasswordUrl: 'usuario/reset-password-url',
  createUsuarioVer: 'usuario/ver',
  readUsuario: 'usuario',
  updateUsuario: 'usuario/persona',
  uploadUsuarioAvatar: 'usuario/{{uuid_usuario}}/avatar'
}

export default usuario
